<template>
  <div
    :class="classes"
    :style="style"
  >
    <m-tooltip
      placement="bottom"
    >
      <template
        v-if="!disableTooltip"
        #title
      >
        <div>{{ name }}</div>
        <div class="_email">
          {{ email }}
        </div>
      </template>
      <user-avatar
        v-if="!hideAvatar"
        :user="user"
        class="_avatar"
        :has-tooltip="hideName"
        :size="sizeOfAvatar"
      />
    </m-tooltip>
    <div
      v-if="!hideName || !!$slots.subName"
      class="_text"
    >
      <div
        v-if="!hideName"
        class="_name"
      >
        {{ name }}
      </div>
      <div
        v-if="!!$slots.subName"
        class="_sub-name"
      >
        <slot name="subName" />
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatar from 'shared/components/UserAvatar.vue';
import useUser from 'shared/composables/user';
import { mStyleProps, resolveStyles } from 'shared/lib/m-style-props';
import { toRef } from 'vue';

export default {
  name: 'UserDisplay',
  props: {
    ...mStyleProps,
    user: {
      type: Object,
      required: true,
    },
    hideAvatar: {
      type: Boolean,
      default: false,
    },
    hideName: {
      type: Boolean,
      default: false,
    },
    xs: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    xl: {
      type: Boolean,
      default: false,
    },
    disableTooltip: {
      type: Boolean,
      default: false,
    },
  },
  components: { UserAvatar },
  setup(props) {
    const { displayName: name, email } = useUser(toRef(props, 'user'));
    return { name, email };
  },
  computed: {
    classes() {
      return [
        'user-display',
        this.xs ? '-xs' : '',
        this.small ? '-small' : '',
        this.large ? '-large' : '',
        this.xl ? '-xl' : '',
      ];
    },
    sizeOfAvatar() {
      if (this.xs) {
        return 18;
      }
      if (this.small) {
        return 20;
      }
      if (this.large) {
        return 30;
      }
      if (this.xl) {
        return 36;
      }
      return undefined;
    },
    fontStyle() {
      const style = {};
      switch (true) {
        case this.xs:
          style.fontSize = this.$fontSizes[2];
          break;
        default:
          style.fontSize = this.$fontSizes[4];
          break;
      }
      return style;
    },
    style() {
      return {
        ...this.fontStyle,
        ...resolveStyles(this.mStyle),
      };
    },
  },
  methods: { resolveStyles },
};
</script>

<style scoped lang="scss" type="text/scss">
  .user-display {
    display: flex;
    gap: .8rem;
    align-items: center;
    max-width: 100%;

    ._text {
      display: flex;
      flex-flow: column;
      overflow: hidden;
      white-space: nowrap;

      ._name {
        overflow: hidden;
        text-overflow: ellipsis;
      }

      ._sub-name {
        overflow: hidden;
        font-size: $font-size-2;
        color: $font-color-tertiary;
        text-overflow: ellipsis;
      }
    }

    &.-xs {
      gap: .4rem;
    }

    &.-small {
      gap: .6rem;
    }

    &.-large {
      gap: 1.2rem;
    }

    &.-xl {
      gap: 1.6rem;
    }
  }

  ._email {
    color: grey;
  }

</style>
